module.exports = __webpack_public_path__ + "media/images/themes/spring_bohemian/ring_semi_transparent3-4091e69bd5c7b1c0a50a09b65aa38f6a.png";